var _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDisconnect = function SvgDisconnect(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2999 14.2L18.3999 16.3L16.2999 18.4",
    stroke: "currentColor",
    strokeWidth: 1.368,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27995 4.96001C3.72551 4.96001 4.15281 4.78301 4.46787 4.46795C4.78293 4.15288 4.95992 3.72557 4.95992 3.28001C4.95992 2.83444 4.78293 2.40713 4.46787 2.09207C4.15281 1.77701 3.72551 1.60001 3.27995 1.60001C2.83439 1.60001 2.40708 1.77701 2.09203 2.09207C1.77697 2.40713 1.59998 2.83444 1.59998 3.28001C1.59998 3.72557 1.77697 4.15288 2.09203 4.46795C2.40708 4.78301 2.83439 4.96001 3.27995 4.96001Z",
    stroke: "currentColor",
    strokeWidth: 1.368,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95959 3.2802H8.31954C8.7651 3.2802 9.19241 3.4572 9.50746 3.77227C9.82252 4.08733 9.99952 4.51464 9.99952 4.9602V14.6202C9.99952 15.0658 10.1765 15.4931 10.4916 15.8081C10.8066 16.1232 11.2339 16.3002 11.6795 16.3002H18.3994",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.59985 17.35L4.74985 13.15M4.74985 17.35L1.59985 13.15",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisconnect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "assets/images/disconnect.svg";
export { ForwardRef as ReactComponent };